var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-operations" },
    [
      _vm._l(_vm.operations, function(operation, i) {
        return [
          _vm.getDisabled(operation) && operation.visible(_vm.params.data)
            ? _c("span", { key: i, staticStyle: { padding: "5px" } }, [
                _vm._v(_vm._s(operation.title))
              ])
            : operation.visible(_vm.params.data)
            ? _c(
                "a",
                {
                  key: i,
                  class: "grid-operations-" + operation.type,
                  style: operation.cssStyle,
                  on: {
                    click: function() {
                      return operation.onClick(_vm.params.data)
                    }
                  }
                },
                [_vm._v(_vm._s(operation.title))]
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }